<div
  [ngClass]="{
    container: true,
    disabled: isDisabled
  }"
>
  <button
    [ngStyle]="buttonStyles"
    [disabled]="isDisabled"
    (click)="handleClick($event)"
    (keydown)="handleClick($event, true)"
    [attr.aria-label]="copy[jsonKey.SPEECH_BUTTON_ARIA_LABEL]"
  ></button>
</div>
